import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import isEqual from "lodash.isequal";
var flatten = require("flat");
var unflatten = require("flat").unflatten;

const getLocalPhoneNumber = (phone) => {
  const phoneNumber = phone ? parsePhoneNumberFromString(phone) : null;
  if (phoneNumber) {
    return phoneNumber.formatNational();
  }
  return phone;
};

const flattenObjectWithPefix = (obj) => {
  let newFlat = {};
  const flat = flatten(obj, {
    safe: true,
  });
  Object.keys(flat).map((key) => {
    const newKey = key.replaceAll(".", "__");
    newFlat[newKey] = flat[key];
  });
  return newFlat;
};

const unFlattenObjectWithPefix = (obj) => {
  let newFlat = {};
  Object.keys(obj).map((key) => {
    const newKey = key.replaceAll("__", ".");
    newFlat[newKey] = obj[key];
  });
  const unFlat = unflatten(newFlat, { safe: true });
  return unFlat;
};

const getChangedItems = (
  changedValues,
  allValues,
  changedItems,
  activeEmployee
) => {
  const key = Object.keys(changedValues)[0];
  const initial = flatten(activeEmployee, {
    safe: true,
  });
  var newChangedItems = changedItems.filter((name) => name !== key);
  let isEqualArray = false;
  if (Array.isArray(initial[key])) {
    const initialArray = initial[key].map(({ key, ...keepAttrs }) => keepAttrs);
    const newArray = changedValues[key].map(
      ({ key, ...keepAttrs }) => keepAttrs
    );
    isEqualArray = isEqual(initialArray, newArray);
  }

  if (
    changedValues[key] !== initial[key] &&
    !isEqualArray &&
    !(changedValues[key] === "" && initial[key] === null)
  ) {
    newChangedItems.push(key);
  }

  return newChangedItems;
};

const getFormChanges = (values, changedItems) => {
  let changes = {};
  changedItems.forEach((item, i) => (changes[item] = values[item]));
  return changes;
};

const getFullName = (surename, firstName) => {
  return `${surename} ${firstName}`;
};

const formatRelativeType = (typeName) => {
 return typeName ? `(${typeName})` : "";
};

const getAddress = (record) => {
  const street =
    record["address.street"] && record["address.street"] !== ""
      ? record["address.street"].trim() +
        " " +
        record["address.house_number"].trim()
      : "";
  const address =
    record["address.city"] && record["address.city"] !== ""
      ? record["address.city"].trim() + ", " + street
      : street;
  return address;
};

const getProffesionalName = (record, intl) => {
  let employeeName = getFullName(record.surename, record.first_name);
  if (record.professional_role_id) {
    const role =
      record.professional_role_id &&
      intl.formatMessage({
        id: `app.mobile.dataSelect.professional_role_id.${record.professional_role_id}`,
      });
    employeeName = employeeName.concat(", ", role);
  }
  return employeeName;
};

const  formatDateString = (dateStr) => {
  return new Intl.DateTimeFormat("he-IL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Jerusalem",
  }).format(new Date(dateStr));
}

const getAgeByDate = (date) => {
  var today = new Date();
  var birthDate = new Date(date);
  var result = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    result--;
  }
  return result;
};

export {
  flattenObjectWithPefix,
  formatDateString,
  formatRelativeType,
  getAddress,
  getAgeByDate,
  getChangedItems,
  getFormChanges,
  getFullName,
  getLocalPhoneNumber,
  getProffesionalName,
  unFlattenObjectWithPefix,
};
